import { uiStrings } from '../actions/ui_strings';

export default function reducerStrings(state = uiStrings, action) {
    return state;
}
